// eslint-disable-next-line import/no-anonymous-default-export
export default {
  home: "/",
  contacts: "/contacts",
  login: "/login",
  register: "/register",
};
